import { View, Text, Pressable, ActivityIndicator } from 'react-native';
import { mazeStrikerViewStyles as styles } from './MazeStrikerView.styles';
import { MAZE_STRIKER_ACCENT, MAZE_STRIKER_TEST_IDS } from '../../../src/quiz/constants/mazeStriker.constants';

interface MazeStrikerOverlaysProps {
  status: 'loading' | 'ready' | 'error';
  onRetry: () => void;
}

/**
 * The host-side overlay layer: loading until the runtime posts `ready`, error + Retry on `load-error`.
 * Everything else (title, HUD, level intros, game over) is drawn by the game's 3D canvas itself.
 */
export function MazeStrikerOverlays({ status, onRetry }: MazeStrikerOverlaysProps) {
  if (status === 'loading') {
    return (
      <View style={styles.overlay} testID={MAZE_STRIKER_TEST_IDS.loading} pointerEvents="none">
        <ActivityIndicator color={MAZE_STRIKER_ACCENT} />
      </View>
    );
  }
  if (status === 'error') {
    return (
      <View style={styles.overlay} testID={MAZE_STRIKER_TEST_IDS.error}>
        <Text style={styles.message}>Could not load the game</Text>
        <Pressable
          testID={MAZE_STRIKER_TEST_IDS.retry}
          onPress={onRetry}
          style={({ pressed }) => [styles.retryButton, pressed && styles.pressedDim]}
        >
          <Text style={styles.retryText}>Retry</Text>
        </Pressable>
      </View>
    );
  }
  return null;
}
